<template>
    <div id="host_activity_rule" :class="isFull === 1 ? 'host_activity_rule top_information1' : ' host_activity_rule'">
        <!-- Top Header Banner -->
        <div class="header-container">
            <van-nav-bar left-arrow @click-left="onClickLeft" placeholder fixed class="transparent-nav" />
            <div class="header-content">
                <div class="sub-title">{{ $t('column.new_task_system') }}</div>
                <div class="main-title">{{ $t('column.host_tasks') }}</div>
                <div class="desc-btn">{{ $t('column.detailed_description') }}</div>
            </div>
        </div>
        <!-- Main Body -->
        <div class="body-container">
            <!-- Notification Box -->
            <div class="notice-box"> {{ $t('column.dear_host_will_adjusting_task_system') }}</div>

            <!-- Rules Divider -->
            <div class="rules-divider">
                <img src="../assets/img/host_activity/host_activity_rule_left.png"/>
                <span class="text">{{ $t('column.Rules') }}</span>
                <img src="../assets/img/host_activity/host_activity_rule_left.png" class="line"/>
            </div>

            <!-- Rules Card -->
            <div class="rules-card2">
                <div class="rule-text-dark">{{ $t('column.daily_host_tasks_based_total_recent_days') }}</div>
                <div class="rule-line"></div>
                <div class="rule-text-purple">{{ $t('column.as_daily_income_increases_task_rewards') }} </div>
            </div>

            <!-- Level Tasks Divider -->
            <div class="rules-divider mt-30">
                <img src="../assets/img/host_activity/host_activity_rule_left.png"/>
                <span class="text">{{ $t('column.Level_tasks') }}</span>
                <img src="../assets/img/host_activity/host_activity_rule_left.png" class="line"/>
            </div>

            <!-- Level Tasks Table -->
            <div class="table-container">
                <table class="task-table">
                    <thead>
                        <tr>
                            <th width="20%">{{ $t('column.Level') }}</th>
                            <th width="40%">{{ $t('column.total_7day_income') }} <span class="coin-icon"><img src="../assets/img/coin9.png"/></span></th>
                            <th width="40%">{{ $t('column.daily_task_reward') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,i) in list" :key="i">
                            <td class="level-text">{{  item.level_name }}</td>
                            <td>{{ item.target_coin }}</td>
                            <td class="reward-text">
                                {{ item.daily_reward }}<span class="coin-icon"><img src="../assets/img/coin9.png"/></span>{{ $t('column.per_hour') }} {{ item.daily_hours }}{{ $t('column.hour_per_day') }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- New Host Divider -->
            <div class="rules-divider mt-30" v-if="new_list && new_list.daily_reward">
                <img src="../assets/img/host_activity/host_activity_rule_left.png"/>
                <span class="text">{{ $t('column.new_host') }}</span>
                <img src="../assets/img/host_activity/host_activity_rule_left.png" class="line"/>
            </div>

            <div class="new-host-desc" v-if="new_list && new_list.daily_reward">
                {{ $t('column.new_host_desc') }}
            </div>

            <!-- New Host Table -->
            <div class="table-container mb-30" v-if="new_list && new_list.daily_reward">
                <table class="task-table new-host-table">
                    <thead>
                        <tr>
                            <th colspan="2">{{ $t('column.daily_task_reward') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td width="30%" class="level-text">{{ $t('column.new_host') }}</td>
                            <td width="70%" class="reward-text">{{ new_list.daily_reward }}<img src="../assets/img/coin9.png"/>{{ $t('column.per_hour') }} {{ new_list.daily_hours }}{{ $t('column.hour_per_day') }} {{ $t('column.days_7') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

           
            <!-- General Host Divider -->
            <div class="rules-divider mt-30" v-if="general_host && general_host.daily_hours > 0">
                <img src="../assets/img/host_activity/host_activity_rule_left.png"/>
                <span class="text">{{ $t('column.general_host') }}</span>
                <img src="../assets/img/host_activity/host_activity_rule_left.png" class="line"/>
            </div>

            <div class="new-host-desc" v-if="general_host && general_host.daily_hours > 0">
                {{ $t('column.general_host_desc') }} <span class="highlight-purple"> < {{ general_host.target_coin }} </span>
            </div>

            <!-- General Host Table -->
            <div class="table-container mb-30" v-if="general_host && general_host.daily_hours > 0">
                <table class="task-table new-host-table">
                    <thead>
                        <tr>
                            <th colspan="2">{{ $t('column.daily_task_reward') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td width="30%" class="level-text">{{ $t('column.general_host') }}</td>
                            <td width="70%" class="reward-text">{{ general_host.daily_reward }}<img src="../assets/img/coin9.png"/>{{ $t('column.per_hour') }} {{ general_host.daily_hours }}{{ $t('column.hour_per_day') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Notes Card -->
            <div class="notes-card mb-30">
                <div class="notes-title">{{ $t('column.notes') }}</div>
                <div class="notes-list">
                    <div class="note-item">
                        <span class="note-num">1.</span>
                        <span class="note-text">{{ $t('column.note_1') }}</span>
                    </div>
                    <div class="note-item">
                        <span class="note-num">2.</span>
                        <span class="note-text">{{ $t('column.note_2') }}</span>
                    </div>
                    <div class="note-item">
                        <span class="note-num">3.</span>
                        <span class="note-text">{{ $t('column.note_3') }}</span>
                    </div>
                    <div class="note-item note-alert">
                        <span class="note-num">4.</span>
                        <span class="note-text">{{ $t('column.note_4') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast } from 'vant'

export default {
  data:function() {
    return {
      new_list:{
        target_coin:0,
        daily_reward: 0,
        daily_hours: 0
      },
      general_host:{
        daily_reward: 0,
        daily_hours: 0,
        target_coin: 0
      },
      list:[]
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.get_list()
  },
  methods: {
    onClickLeft() {
      // 拦截关闭h5
      this.$router.go(-1);
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=host_activity&act=host_activity_rule",{ params:{token: token }}).then(res =>{
        console.log(res)
        // 加载状态结束
          this.loading = false
        if(res.data.status===1){
          this.list = res.data.data.list
          this.new_list = res.data.data.new_list
          this.general_host = res.data.data.general_host
          this.finished = true
          this.loading = false
        }else{
          // 数据全部加载完成
          this.finished = true
          Toast.fail(res.data.error);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/host_activity_rule.vue